/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    keycloakId: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    organizationId: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    emailOnFormCreated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    emailOnFormSubmitted?: boolean;
    /**
     * Whether to receive email when someone else updates a form the user created
     * @type {boolean}
     * @memberof UserDto
     */
    emailOnFormUpdated?: boolean;
    /**
     * Whether to receive email when someone comments on a form the user created
     * @type {boolean}
     * @memberof UserDto
     */
    emailOnCommentAdded?: boolean;
    /**
     * Active signing provider for this user. Null defaults to signius. Only configurable by admin roles.
     * @type {string}
     * @memberof UserDto
     */
    signingProvider?: UserDtoSigningProviderEnum | null;
}


/**
 * @export
 */
export const UserDtoSigningProviderEnum = {
    Mock: 'mock',
    Signius: 'signius'
} as const;
export type UserDtoSigningProviderEnum = typeof UserDtoSigningProviderEnum[keyof typeof UserDtoSigningProviderEnum];


/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value: object): value is UserDto {
    if (!('keycloakId' in value) || value['keycloakId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'keycloakId': json['keycloakId'],
        'name': json['name'],
        'organizationId': json['organizationId'],
        'email': json['email'] == null ? undefined : json['email'],
        'emailOnFormCreated': json['emailOnFormCreated'] == null ? undefined : json['emailOnFormCreated'],
        'emailOnFormSubmitted': json['emailOnFormSubmitted'] == null ? undefined : json['emailOnFormSubmitted'],
        'emailOnFormUpdated': json['emailOnFormUpdated'] == null ? undefined : json['emailOnFormUpdated'],
        'emailOnCommentAdded': json['emailOnCommentAdded'] == null ? undefined : json['emailOnCommentAdded'],
        'signingProvider': json['signingProvider'] == null ? undefined : json['signingProvider'],
    };
}

export function UserDtoToJSON(json: any): UserDto {
    return UserDtoToJSONTyped(json, false);
}

export function UserDtoToJSONTyped(value?: UserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'keycloakId': value['keycloakId'],
        'name': value['name'],
        'organizationId': value['organizationId'],
        'email': value['email'],
        'emailOnFormCreated': value['emailOnFormCreated'],
        'emailOnFormSubmitted': value['emailOnFormSubmitted'],
        'emailOnFormUpdated': value['emailOnFormUpdated'],
        'emailOnCommentAdded': value['emailOnCommentAdded'],
        'signingProvider': value['signingProvider'],
    };
}

